import { Link } from 'react-router-dom';
import TranslationBtn from '../../components/TranslationBtn/TranslationBtn';
import './DesktopMenu.scss';

function DesktopMenu(props) {
  return (
    <nav className='desktop-menu'>
        <div className='nav-links'>
          <Link to='/'>{ props.title1 }</Link>
          <Link to='/sobre' id='more-about'>{ props.title2 }</Link>
          <Link to='/contatos'>{ props.title3 }</Link>
        </div>
        <TranslationBtn />
    </nav>
  )
}

export default DesktopMenu;
